import React from "react";

/**
 * 紫ボタンコンポーネント
 * @param {string} title ボタンタイトル
 * @param {String} icon アイコン
 * @param {Function} onClick ボタン押下時の処理
 * @param {string} className クラス名
 * @class GreenButton
 */

const Icon = ({ name }) => {
  if (name === "logout") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M10 17l5-5-5-5M15 12H3"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 5h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  return null;
};

export default function PurpleButton({ title, icon, onClick, className = "" }) {
  return (
    <button className={`btn btn-purple ${className}`} onClick={onClick}>
      <Icon name={icon} />
      {title}
    </button>
  );
}
